import { render, staticRenderFns } from "./DuplicateUserMediaModal.vue?vue&type=template&id=7822885c&scoped=true&"
import script from "./DuplicateUserMediaModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateUserMediaModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateUserMediaModal.vue?vue&type=style&index=0&id=7822885c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7822885c",
  null
  
)

export default component.exports